// External libraries
import debounce from 'lodash.debounce';

// Internal modules
import { getLocale, noop } from '@/lib';
import { handleCountryChange } from '../shared';
import { shouldDebounceCountryChange } from './utils';
import type { CountryCodes } from '@/generated/graphql';
import type { OnShippingChangeWrapper } from '@/lib/utils/shipping/types';
import type { Noop } from '@/types';

const DEBOUNCE_DELAY = 1200;
const changeCountry = shouldDebounceCountryChange()
  ? debounce(handleCountryChange, DEBOUNCE_DELAY)
  : handleCountryChange;

const getCountryChangeHandler = (
  isDisabled: boolean,
  onShippingCallback: OnShippingChangeWrapper | Noop = noop,
) => {
  return (
    toCountry: CountryCodes,
    e?: React.ChangeEvent<HTMLSelectElement>,
  ): void => {
    if (e) {
      e.preventDefault();
    }
    if (isDisabled) {
      return;
    }

    const fromCountry = getLocale().country;
    changeCountry({ fromCountry, toCountry }, onShippingCallback);
  };
};

export { getCountryChangeHandler };
